import _extends from "@babel/runtime/helpers/esm/extends";
import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";
import { apiRunner, apiRunnerAsync } from "./api-runner-browser";
import React from "react";
import ReactDOM from "react-dom";
import { Router, navigate, Location, BaseContext } from "@reach/router";
import { ScrollContext } from "gatsby-react-router-scroll";
import domReady from "@mikaelkristiansson/domready";
import { StaticQueryContext } from "gatsby";
import { shouldUpdateScroll, init as navigationInit, RouteUpdates } from "./navigation";
import emitter from "./emitter";
import PageRenderer from "./page-renderer";
import asyncRequires from "$virtual/async-requires";
import { setLoader, ProdLoader, publicLoader, PageResourceStatus, getStaticQueryResults } from "./loader";
import EnsureResources from "./ensure-resources";
import stripPrefix from "./strip-prefix";

// Generated during bootstrap
import matchPaths from "$virtual/match-paths.json";
import { jsx as ___EmotionJSX } from "@emotion/core";
const loader = new ProdLoader(asyncRequires, matchPaths);
setLoader(loader);
loader.setApiRunner(apiRunner);
window.asyncRequires = asyncRequires;
window.___emitter = emitter;
window.___loader = publicLoader;
navigationInit();
apiRunnerAsync("onClientEntry").then(() => {
  // Let plugins register a service worker. The plugin just needs
  // to return true.
  if (apiRunner("registerServiceWorker").length > 0) {
    require("./register-service-worker");
  }

  // In gatsby v2 if Router is used in page using matchPaths
  // paths need to contain full path.
  // For example:
  //   - page have `/app/*` matchPath
  //   - inside template user needs to use `/app/xyz` as path
  // Resetting `basepath`/`baseuri` keeps current behaviour
  // to not introduce breaking change.
  // Remove this in v3
  const RouteHandler = props => ___EmotionJSX(BaseContext.Provider, {
    value: {
      baseuri: "/",
      basepath: "/"
    }
  }, ___EmotionJSX(PageRenderer, props));
  const DataContext = /*#__PURE__*/React.createContext({});
  let GatsbyRoot = /*#__PURE__*/function (_React$Component) {
    _inheritsLoose(GatsbyRoot, _React$Component);
    function GatsbyRoot() {
      return _React$Component.apply(this, arguments) || this;
    }
    var _proto = GatsbyRoot.prototype;
    _proto.render = function render() {
      const {
        children
      } = this.props;
      return ___EmotionJSX(Location, null, _ref => {
        let {
          location
        } = _ref;
        return ___EmotionJSX(EnsureResources, {
          location: location
        }, _ref2 => {
          let {
            pageResources,
            location
          } = _ref2;
          const staticQueryResults = getStaticQueryResults();
          return ___EmotionJSX(StaticQueryContext.Provider, {
            value: staticQueryResults
          }, ___EmotionJSX(DataContext.Provider, {
            value: {
              pageResources,
              location
            }
          }, children));
        });
      });
    };
    return GatsbyRoot;
  }(React.Component);
  let LocationHandler = /*#__PURE__*/function (_React$Component2) {
    _inheritsLoose(LocationHandler, _React$Component2);
    function LocationHandler() {
      return _React$Component2.apply(this, arguments) || this;
    }
    var _proto2 = LocationHandler.prototype;
    _proto2.render = function render() {
      return ___EmotionJSX(DataContext.Consumer, null, _ref3 => {
        let {
          pageResources,
          location
        } = _ref3;
        return ___EmotionJSX(RouteUpdates, {
          location: location
        }, ___EmotionJSX(ScrollContext, {
          location: location,
          shouldUpdateScroll: shouldUpdateScroll
        }, ___EmotionJSX(Router, {
          basepath: __BASE_PATH__,
          location: location,
          id: "gatsby-focus-wrapper"
        }, ___EmotionJSX(RouteHandler, _extends({
          path: pageResources.page.path === "/404.html" ? stripPrefix(location.pathname, __BASE_PATH__) : encodeURI(pageResources.page.matchPath || pageResources.page.path)
        }, this.props, {
          location: location,
          pageResources: pageResources
        }, pageResources.json)))));
      });
    };
    return LocationHandler;
  }(React.Component);
  const {
    pagePath,
    location: browserLoc
  } = window;

  // Explicitly call navigate if the canonical path (window.pagePath)
  // is different to the browser path (window.location.pathname). But
  // only if NONE of the following conditions hold:
  //
  // - The url matches a client side route (page.matchPath)
  // - it's a 404 page
  // - it's the offline plugin shell (/offline-plugin-app-shell-fallback/)
  if (pagePath && __BASE_PATH__ + pagePath !== browserLoc.pathname && !(loader.findMatchPath(stripPrefix(browserLoc.pathname, __BASE_PATH__)) || pagePath === "/404.html" || pagePath.match(/^\/404\/?$/) || pagePath.match(/^\/offline-plugin-app-shell-fallback\/?$/))) {
    navigate(__BASE_PATH__ + pagePath + browserLoc.search + browserLoc.hash, {
      replace: true
    });
  }
  publicLoader.loadPage(browserLoc.pathname).then(page => {
    if (!page || page.status === PageResourceStatus.Error) {
      throw new Error("page resources for " + browserLoc.pathname + " not found. Not rendering React");
    }
    window.___webpackCompilationHash = page.page.webpackCompilationHash;
    const SiteRoot = apiRunner("wrapRootElement", {
      element: ___EmotionJSX(LocationHandler, null)
    }, ___EmotionJSX(LocationHandler, null), _ref4 => {
      let {
        result
      } = _ref4;
      return {
        element: result
      };
    }).pop();
    const App = () => ___EmotionJSX(GatsbyRoot, null, SiteRoot);
    const renderer = apiRunner("replaceHydrateFunction", undefined, ReactDOM.hydrate)[0];
    domReady(() => {
      renderer(___EmotionJSX(App, null), typeof window !== "undefined" ? document.getElementById("___gatsby") : void 0, () => {
        apiRunner("onInitialClientRender");
      });
    });
  });
});